import renderModule from "./render/module";

export default function load(container) {
    renderModule({
        bind: container.bind
    });
}
//# sourceMappingURL=modules.js.map
